import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Card from '@/components/layout/Card.vue';
import { RightManagementKey, RightManagementKeyGroup } from '@/store/enums/rightManagementEnum';
import { RightManagementKeyParam } from '@/store/models/rightManagement';
import store from '@/store';
import { RIGHT_MANAGMENT_CHANGE_FOR_KEY } from '@/store/actions/rightManagement';
var UserRightManagement = /*#__PURE__*/function (_Vue) {
  function UserRightManagement() {
    var _this;
    _classCallCheck(this, UserRightManagement);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserRightManagement, [].concat(args));
    _defineProperty(_this, "user", void 0);
    return _this;
  }
  _inherits(UserRightManagement, _Vue);
  return _createClass(UserRightManagement, [{
    key: "getValueForKey",
    value: function getValueForKey(key) {
      var _iterator = _createForOfIteratorHelper(new Set(this.user.rightManagement)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rm = _step.value;
          if (rm.key === key) {
            return rm.value === "true";
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "isUserUpdateAivalable",
    get: function get() {
      return store.getters.isUpdateUserAivailable;
    }
  }, {
    key: "isMe",
    get: function get() {
      var userConnected = store.getters.userConnected;
      if (this.user.userID === userConnected.userID) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "changeValueFor",
    value: function changeValueFor(key) {
      var value = this.getValueForKey(key);
      var params = new RightManagementKeyParam();
      params.user = this.user;
      params.key = key;
      params.value = !value + '';
      store.dispatch(RIGHT_MANAGMENT_CHANGE_FOR_KEY, params);
    }
    // set the good style/type for a value of a group
  }, {
    key: "getTypeFor",
    value: function getTypeFor(keyGroup) {
      var value = this.getGroupValue(keyGroup);
      if (value.total === value.active) {
        return 'is-success';
      }
      if (value.active === 0) {
        return 'is-light';
      }
      if (value.active > 0) {
        return 'is-warning';
      }
    }
    // Compute the value of a group of right management
  }, {
    key: "getGroupValue",
    value: function getGroupValue(key) {
      var numberOfKeyActive = 0;
      var totalOfKey = 0;
      var _iterator2 = _createForOfIteratorHelper(new Set(this.user.rightManagement)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rm = _step2.value;
          // we verify that the RM is in enumerer
          if (rm.rightManagementGroup.includes(key) && Object.values(RightManagementKey).includes(RightManagementKey[rm.key])) {
            if (rm.value === "true") {
              numberOfKeyActive++;
            }
            totalOfKey++;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return {
        active: numberOfKeyActive,
        total: totalOfKey
      };
    }
  }, {
    key: "rightManagementKey",
    get: function get() {
      return RightManagementKey;
    }
  }, {
    key: "rightManagementGroupKey",
    get: function get() {
      return RightManagementKeyGroup;
    }
  }]);
}(Vue);
__decorate([Prop()], UserRightManagement.prototype, "user", void 0);
UserRightManagement = __decorate([Options({
  components: {
    Card: Card
  }
})], UserRightManagement);
export default UserRightManagement;